import * as React from 'react';
import { AnchorListContext } from './types';

const AnchorContext = React.createContext<AnchorListContext>(null as any);

export default AnchorContext;